export default "__VITE_ASSET__EeQOriB6__"